<div class="fh-modal" role="dialog" aria-modal="true" aria-labelledby="convention-modal-title">
  <div class="fh-modal-backdrop" (click)="closed.emit()"></div>
  <div class="fh-modal-panel">
    <div class="fh-modal-head">
      <span class="line-tile tone-caregiving"><i class="bi bi-patch-check"></i></span>
      <div class="flex-grow-1 min-w-0">
        <h2 id="convention-modal-title" class="h5 fw-semibold mb-0">{{ isEdit ? 'Modifica convenzione' : 'Crea convenzione' }}</h2>
        <div class="small text-muted-fh">
          {{ isEdit ? 'Convenzione ' + convention!.id : 'I prezzi dei prodotti B2B si aggiungono dal catalogo' }}
        </div>
      </div>
      <button type="button" class="icon-btn" (click)="closed.emit()" aria-label="Chiudi">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>

    <div class="fh-modal-body">
      <form [formGroup]="form" (ngSubmit)="submit()" class="row g-3">
        <div class="col-12">
          <span class="form-label d-block">Stato</span>
          <div class="segmented">
            <button
              type="button"
              *ngFor="let s of statuses"
              [class.active]="form.get('status')?.value === s"
              (click)="form.patchValue({ status: s })"
            >
              {{ statusLabels[s] }}
            </button>
          </div>
        </div>

        <div class="col-sm-6">
          <label class="form-label" for="cnv-from">Valida dal</label>
          <input id="cnv-from" type="date" class="form-control" formControlName="validFrom" />
          <span class="form-error" *ngIf="(form.get('validFrom')?.touched || formInvalid) && form.get('validFrom')?.invalid">
            Questo campo è obbligatorio
          </span>
        </div>
        <div class="col-sm-6">
          <label class="form-label" for="cnv-to">Al</label>
          <input id="cnv-to" type="date" class="form-control" formControlName="validTo" />
          <span class="form-error" *ngIf="(form.get('validTo')?.touched || formInvalid) && form.get('validTo')?.invalid">
            Questo campo è obbligatorio
          </span>
          <span class="form-error" *ngIf="form.errors?.['dates']">La fine non può essere prima dell'inizio</span>
        </div>

        <div class="col-sm-6">
          <label class="form-label" for="cnv-hours">Monte ore totale</label>
          <div class="input-group">
            <input id="cnv-hours" type="number" min="0" step="1" class="form-control text-end" formControlName="totalHours" placeholder="—" />
            <span class="input-group-text">ore</span>
          </div>
        </div>

        <div class="col-12">
          <div class="pool-box">
            <div class="d-flex align-items-center justify-content-between gap-3">
              <div>
                <div class="fw-medium small">Monte ore condiviso</div>
                <div class="hint">Ore che i dipendenti possono usare su più servizi</div>
              </div>
              <div class="form-check form-switch m-0">
                <input class="form-check-input" type="checkbox" role="switch" formControlName="poolEnabled" aria-label="Monte ore condiviso" />
              </div>
            </div>

            <div *ngIf="poolEnabled" class="row g-3 mt-1">
              <div class="col-sm-6">
                <label class="form-label" for="cnv-pool-hours">Ore condivise</label>
                <div class="input-group">
                  <input id="cnv-pool-hours" type="number" min="0" step="1" class="form-control text-end" formControlName="poolHours" placeholder="—" />
                  <span class="input-group-text">ore</span>
                </div>
              </div>
              <div class="col-12">
                <span class="form-label d-block">Servizi che usano il monte ore</span>
                <div class="d-flex flex-wrap gap-2">
                  <button
                    type="button"
                    *ngFor="let line of lineOptions"
                    class="line-pill"
                    [class.on]="poolLines.includes(line)"
                    [attr.aria-pressed]="poolLines.includes(line)"
                    (click)="togglePoolLine(line)"
                  >
                    <i class="bi" [ngClass]="poolLines.includes(line) ? 'bi-check-lg' : lineOf(line).icon"></i>{{ lineOf(line).label }}
                  </button>
                  <span *ngIf="!lineOptions.length" class="hint">Collega prima dei servizi all'azienda.</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>

      <div *ngIf="confirmDelete" class="notice mt-3">
        <i class="bi bi-exclamation-triangle me-1"></i>
        La convenzione e tutti i suoi prezzi verranno eliminati. Premi «Conferma eliminazione» per procedere.
      </div>
      <div *ngIf="errorText" class="alert alert-danger small mt-3 mb-0">{{ errorText }}</div>
    </div>

    <div class="fh-modal-foot">
      <button *ngIf="isEdit" type="button" class="danger-link" [disabled]="saving" (click)="deleteConvention()">
        <i class="bi bi-trash3 me-1"></i>{{ confirmDelete ? 'Conferma eliminazione' : 'Elimina' }}
      </button>
      <span *ngIf="!isEdit" class="hint">Solo dimostrativa: nessun effetto sui pagamenti.</span>
      <div class="d-flex gap-2">
        <button type="button" class="btn btn-light" (click)="closed.emit()">Annulla</button>
        <button type="button" class="btn btn-primary text-light" [disabled]="saving" (click)="submit()">
          <span *ngIf="saving" class="spinner-border spinner-border-sm me-1"></span>{{ isEdit ? 'Salva' : 'Crea convenzione' }}
        </button>
      </div>
    </div>
  </div>
</div>
